<template>
    <el-dialog title="Multi-account CBR Calculator"
               width="1100px"
               top="50px"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <el-row>
            <el-col :span="4">
                <label>Include Lead Types</label>
            </el-col>    
            <el-col :span="8">
                <el-checkbox v-model="formData.include_mc" @change="refresh()">MC</el-checkbox>
                <el-checkbox v-model="formData.include_job_board" @change="refresh()">Job Board</el-checkbox>
                <el-checkbox v-model="formData.include_job_adviser" @change="refresh()">Job Adviser</el-checkbox>
            </el-col>    
        </el-row>
        <el-row class="mt-10">
            <el-col :span="4">
                <label>Cap increase at</label>
            </el-col>    
            <el-col :span="4">
                <div class="input-group"  style="width: 160px" >
                    <input type="number" class="form-control" v-model="formData.cap_increase"/>
                    <span class="input-group-addon">%</span>
                </div>
            </el-col>
            <el-col :span="4">
                <btn :click="refresh">Apply cap</btn>
            </el-col>
        </el-row>

        <div v-loading="loading">
            <div class="mt-10">
                <el-input type="textarea" v-model="formData.header" rows="5"></el-input>
            </div>

            <div class="table-responsive mt-10">
                <table class="table table-striped table-hover">
                    <tbody>
                    <tr>
                        <th>Account</th>
                        <th>MC Lead Count</th>
                        <th>Job Board Lead Count</th>
                        <th>JA Lead Count</th>
                        <th>Recommended Budget</th>
                        <th>Current Budget</th>
                    </tr>
                    <tr v-for="account in formData.data">
                        <td>{{ account.name }}</td>
                        <td>{{ account.this.mc_leads }}</td>
                        <td>{{ account.this.jb_leads }}</td>
                        <td>{{ account.this.ja_leads }}</td>
                        <td>{{ money(account.this.budget) }}</td>
                        <td>{{ money(account.this.current_budget) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <el-input type="textarea" v-model="formData.footer" rows="5"></el-input>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="send()">Send email to myself</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'selected_employers',
    ],
    data() {
        return {
            formData : {
                include_mc: true,
                include_job_board: true,
                include_job_adviser: true,
                cap_increase: 30,
                header: '',
                data: [],
                footer: '',
            },
            month: '',
            loading: false,
        };
    },
    watch: {
        show() {
            if (this.show) {
                this.refresh();
            }
        }
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.post(url(`admin/estimates/send-cbr/multi-account/data`), {
                employer_ids: this.selected_employers,
                include_mc: this.formData.include_mc,
                include_job_board: this.formData.include_job_board,
                include_job_adviser: this.formData.include_job_adviser,
                cap_increase: this.formData.cap_increase,
            }).then(response => {
                this.formData.header = response.data.header;
                this.formData.data = response.data.data;
                this.formData.footer = response.data.footer;
                this.loading = false;
            })
        },
        send() {
            return axios.post(url(`admin/estimates/send-cbr/multi-account/send-email`), {
                data: this.formData
            }).then(response => {
                this.$message.success(`Email sent to ${response.data.send_to}`);
            })
        }
    },
}
</script>
